module.exports = __webpack_public_path__ + "img/vertical_3_7_9016.8e951882.png";